import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    Controlled_EnumInput,
    type Controlled_EnumInputProps,
} from '../../inputs/controlled/Controlled_EnumInput';
import type { ValueOrNullableValue } from '../../inputs/controlled/types';

export type Form_EnumInputProps<
    T extends object,
    N extends boolean,
    E extends string,
> = Merge<
    Except<
        Controlled_EnumInputProps<E, N>,
        keyof useField.Result<ValueOrNullableValue<N, E>>
    >,
    useField.Props<ValueOrNullableValue<N, E>, T>
>;

export const Form_EnumInput = <
    T extends object,
    N extends boolean,
    E extends string,
>({
    name,
    control,
    onChange,
    ...props
}: Form_EnumInputProps<T, N, E>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_EnumInput
            {...props}
            {...fieldProps}
        />
    );
};
